import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserApi } from '../services/user-api.service';
import { environment } from '../../../../environments/environment';
import { UserType } from '../enums/shared-enums.enum';

declare const io: any;

@Injectable({
  providedIn: 'root',
})
export class CustomerDriversTrackingService {
  socket: any;

  constructor(private userApi: UserApi) {}

  connect(id: number, userType: UserType) {
    let idKeyName;
    switch (userType) {
      case UserType.ORGANIZATION:
        idKeyName = 'organizationId';
        break;
      case UserType.CUSTOMER:
        idKeyName = 'customerId';
        break;
    }

    this.socket = io(environment.socket_url, {
      query: {
        token: `Bearer ${this.userApi.currentUser$.value.accessToken}`,
        [idKeyName]: id,
      },
    });
  }

  listen(eventName: string) {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data);
      });

      return (): void => {
        this.socket.removeAllListeners();
        this.socket.disconnect();
      };
    });

  }
}
